export type GlobalHeaderVisibility = {
  /** The page is one a signed-in user reaches inside the app. */
  authenticatedPage: boolean
  /** The route is a running instance of a resource. */
  isRunningInstance: boolean
  /** The AI assistant is open. */
  assistOn: boolean
  /** The assistant's rail is still on its way out. */
  railLeaving: boolean
}

/**
 * Whether the global header is on screen. Only on authenticated pages; and a running instance owns
 * the whole page, so there the header is the AI assistant's: it shows while the assistant is open,
 * and through the rail's leaving motion, which plays under the header.
 */
export function isGlobalHeaderShown({
  authenticatedPage,
  isRunningInstance,
  assistOn,
  railLeaving,
}: GlobalHeaderVisibility): boolean {
  return authenticatedPage && (!isRunningInstance || assistOn || railLeaving)
}
